import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASES_QUERY_KEY } from "../types/CommonTypes";
import useSelectedHospitalValue from "../../hospitalModule/hooks/useSelectedHospitalValue";

async function getCasesData(
  params: Record<string, any>,
  tenantId?: string,
  hospitalId?: string
) {
  const { data } = await fetcher({
    url: `/cases`,
    method: "GET",
    params,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export function useGetCasesQuery(
  params: Record<string, any>,
  enabled: boolean,
  tenantId?: string,
  hospitalId?: string
) {
  const { timeZone } = useSelectedHospitalValue();
  params.timeZone = timeZone;
  return useQuery({
    queryKey: [GET_CASES_QUERY_KEY, params, hospitalId],
    queryFn: () => getCasesData(params, tenantId, hospitalId),
    enabled,
  });
}
